module.exports = __webpack_public_path__ + "src/img/trans/ipad_ok_landscape.png?798e53cfeee7b5d30b4c92b53c163d0f";


//////////////////
// WEBPACK FOOTER
// ./src/img/trans/ipad_ok_landscape.png
// module id = 210
// module chunks = 0